import { Fragment, FunctionComponent } from "react";
import {
  DefaultButton,
  TextInputField,
  ToggleField,
  FieldSpy,
  Grid,
  GridItem,
  NoDataTile,
  Separator,
  Stack,
  Text,
  useFieldArray,
  useFormContext
} from "@bps/fluent-ui";
import { DangerButton } from "@components/buttons/DangerButton";
import { usePermissionsCheckQuery } from "@libs/api/gateways/env/env-gateway.hooks";
import { Permissions } from "@libs/permissions/permissions.enum";
import { MobileAppFormValues, VersionListItem } from "./mobile-app-form.types";

export const MobileAppFormFields: FunctionComponent = () => {
  const {
    actions: { setValue }
  } = useFormContext<MobileAppFormValues>();

  const {
    value: appVersions,
    actions: { remove, push }
  } = useFieldArray<VersionListItem>("appVersions");

  const { data: hasWritePermission } = usePermissionsCheckQuery(
    [Permissions.BhMobileAppWrite],
    "or"
  );

  const hasAppVersions = appVersions && appVersions?.length > 0;

  return (
    <>
      <FieldSpy name="maintenanceModeEnabled">
        {maintenanceModeEnabled => (
          <TextInputField
            label="Maintenance Mode Description"
            name="maintenanceModeDescription"
            multiline
            disabled={!maintenanceModeEnabled}
          />
        )}
      </FieldSpy>

      <ToggleField
        name="maintenanceModeEnabled"
        label="Maintenance Mode Enabled"
      />
      <FieldSpy<boolean>
        name="maintenanceModeEnabled"
        onChange={maintenanceModeEnabled => {
          if (maintenanceModeEnabled) {
            setValue("maintenanceModeDescription", "");
          }
        }}
      />
      <Separator />

      <Stack horizontalAlign="start">
        <Text variant="xLarge">Force Upgrade</Text>
      </Stack>

      <TextInputField
        label="Minimum version number"
        name="minimumVersionNumber"
        styles={{
          root: {
            width: "200px"
          }
        }}
      />

      {!hasAppVersions && (
        <NoDataTile
          textProps={{
            text:
              "No app versions available. Click 'Add version' to add a new entry."
          }}
          linkProps={{
            onClick: () => push({ Message: "", Version: "" }),
            text: "Add version"
          }}
        />
      )}

      {hasAppVersions && (
        <Grid
          templateColumns="100px 1fr 148px"
          childrenTokens={{ gap: 8 }}
          verticalAlign="center"
        >
          <Text bold>Version</Text>
          <Text bold>Message</Text>

          <GridItem>
            {hasWritePermission && (
              <DefaultButton
                onClick={() => push({ Message: "", Version: "" })}
                styles={{ root: { width: "fit-content" } }}
                iconProps={{ iconName: "Add" }}
              >
                Add version
              </DefaultButton>
            )}
          </GridItem>

          {appVersions.map((version: VersionListItem, index: number) => (
            <Fragment key={version.Version}>
              <TextInputField name={`appVersions[${index}].Version`} />
              <TextInputField name={`appVersions[${index}].Message`} />
              <DangerButton onClick={() => remove(index)}>Delete</DangerButton>
            </Fragment>
          ))}
        </Grid>
      )}
    </>
  );
};
